import React from "react";
import { PhoneMissed, Phone, ThumbsUp, ThumbsDown, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Status counts that make up the total number of calls
const TOTAL_KEYS = ["callNew", "callNotAnswering", "callFollowUp", "callInterested", "callNotInterested", "callClosed"];

const STATUS_CONFIG = [
  { key: "callNotAnswering", label: "Not Answered",  icon: PhoneMissed, color: "#64748B", bg: "#F8FAFC", to: "/call-logs?status=Not Answering" },
  { key: "callFollowUp",     label: "Follow-up List", icon: Phone,       color: "#F97316", bg: "#FFF7ED", to: "/call-logs?status=Follow-up" },
  { key: "callInterested",   label: "Interested",     icon: ThumbsUp,    color: "#10B981", bg: "#ECFDF5", to: "/call-logs?status=Interested" },
  { key: "callNotInterested",label: "Not Interested", icon: ThumbsDown,  color: "#F43F5E", bg: "#FFF1F2", to: "/call-logs?status=Not Interested" },
];

export default function CallLogStatusCard({ stats }) {
  const navigate = useNavigate();

  const totalCalls = TOTAL_KEYS.reduce((sum, k) => sum + (stats[k] ?? 0), 0);

  const items = [
    { key: "callTotal", label: "Total Calls", icon: PhoneCall, color: "#3B82F6", bg: "#EFF6FF", to: "/call-logs", value: totalCalls },
    ...STATUS_CONFIG.map(s => ({ ...s, value: stats[s.key] ?? 0 })),
  ];

  return (
    <div className="call-log-status-card">
      <div className="call-log-status-header">
        <span className="call-log-status-badge">Call Log Status</span>
        <span className="call-log-status-total">
          {totalCalls} total calls
        </span>
      </div>
      <div className="call-log-status-row">
        {items.map((s, i) => {
          const Icon = s.icon;
          const count = s.value;
          return (
            <React.Fragment key={s.key}>
              {i > 0 && <div className="call-log-divider" />}
              <div className="call-log-status-item" onClick={() => navigate(s.to)}>
                <div className="call-log-icon" style={{ background: s.bg, color: s.color }}>
                  <Icon size={16} />
                </div>
                <span className="call-log-count" style={{ color: count > 0 ? "#0F172A" : "#94A3B8" }}>
                  {count}
                </span>
                <span className="call-log-label">{s.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
